import * as Yup from "yup";
import verifyFormModel from "./formModel";
import states from "../constants/states";

const {
  formField: {
    firstName,
    lastName,
    line1,
    locality,
    region,
    postalcode,
    ssnToken,
    ein,
    eligibilityQuestion,
    companyName,
  },
} = verifyFormModel;

// Business designation patterns to check for
const businessDesignations = [
  "llc", "l.l.c.", "l.l.c", "l.l.c.", "l.l.c", "l.l.c.", "l.l.c", "l.l.c.", "l.l.c", 
  "inc", "i.n.c.", "i.n.c", "i.n.c.", "i.n.c", "i.n.c.", "i.n.c", "i.n.c.", "i.n.c", 
  "corp", "corporation", "c.o.r.p.", "c.o.r.p", "c.o.r.p.", "c.o.r.p", "c.o.r.p.", "c.o.r.p", "c.o.r.p.", "c.o.r.p", 
  "ltd", "limited", "l.t.d.", "l.t.d", "l.t.d.", "l.t.d", "l.t.d.", "l.t.d", "l.t.d.", "l.t.d", 
  "company", "c.o.", "c.o", "c.o.", "c.o", "c.o.", "c.o", "c.o.", "c.o", 
  "business", "enterprises", "group", "associates", "partners", "partnership", "proprietorship"
];

// Reusable function to check if a value contains a business designation
const hasBusinessDesignation = (value) => {
  if (!value) return false; // Skip validation if empty
  const lowerValue = value.toLowerCase();
  
  // Check for exact matches or if the designation is at the end of the string
  return businessDesignations.some(designation => {
    const designationLower = designation.toLowerCase();
    // Check for exact match
    if (lowerValue === designationLower) return true;
    
    // Check if the designation is at the end of the string (with optional punctuation)
    // Use word boundary to ensure it's a complete word, not part of another word
    // Escape special regex characters to prevent issues
    const escapedDesignation = designationLower.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`\\b${escapedDesignation}\\b$`);
    return regex.test(lowerValue);
  });
};

export default [
  Yup.object().shape({
    [firstName.name]: Yup.string()
      .required(`${firstName.requiredErrorMsg}`)
      .test(
        "business-name-check",
        `${firstName.businessNameErrorMsg}`,
        (value) => !hasBusinessDesignation(value)
      ),
    [lastName.name]: Yup.string()
      .required(`${lastName.requiredErrorMsg}`)
      .test(
        "business-name-check",
        `${lastName.businessNameErrorMsg}`,
        (value) => !hasBusinessDesignation(value)
      ),
    [companyName.name]: Yup.string().when('hasBusinessEntity', {
      is: true,
      then: Yup.string(),
      otherwise: Yup.string(),
    }),
    [line1.name]: Yup.string().nullable().required(`${line1.requiredErrorMsg}`),
    [locality.name]: Yup.string().nullable().required(`${locality.requiredErrorMsg}`),
    [region.name]: Yup.string()
      .nullable()
      .required(`${region.requiredErrorMsg}`)
      .test(region.name, region.invalidErrorMsg, (value) => {
        if (value) {
          return Object.keys(states).includes(value.toUpperCase());
        }
      }),
    [postalcode.name]: Yup.string()
      .nullable()
      .required(`${postalcode.requiredErrorMsg}`)
      .test(
        "len",
        `${postalcode.invalidErrorMsg}`,
        (val) => val && val.length === 5
      ),
    // NOTE: ---- KEEPING OPTIONAL FOR NOW 11/21/23 -----
    //
    // [ssnToken.name]: Yup.string().when('hasBusinessEntity', {
    //   is: false,
    //   then: Yup.string().required(`${ssnToken.requiredErrorMsg}`),
    //   otherwise: Yup.string(),
    // }),
    // [ein.name]: Yup.string().when('hasBusinessEntity', {
    //   is: true,
    //   then: Yup.string().required(`${ein.requiredErrorMsg}`),
    //   otherwise: Yup.string(),
    // }),

    // second page rules
    [eligibilityQuestion.name]: Yup.string().when("activeStep", {
      is: 2,
      then: Yup.string().required(`${eligibilityQuestion.requiredErrorMsg}`),
      otherwise: Yup.string(),
    }),
  }),
];
